import { CircularProgress } from "@mui/material";
import classNames from 'classnames';
import React from "react";

type ILoader = {
  color?: "primary" | "secondary" | "inherit";
  size?: number;
  className?: string;
};

const Loader = ({ color, size, className }: ILoader) => {
  return (
    <div className={classNames('loader', className)}>
      <CircularProgress color={color} size={size} />
    </div>
  );
};

export default Loader;
